import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly message = signal<string | null>(null);
  private timer: ReturnType<typeof setTimeout> | null = null;

  open(message: string, _action?: string, config?: { duration?: number }): void {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.message.set(message);
    this.timer = setTimeout(() => {
      this.message.set(null);
      this.timer = null;
    }, config?.duration ?? 3200);
  }

  dismiss(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.message.set(null);
  }
}
